// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_setup_progress".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "organization_setup_progress" table (1:1 with a DB row, on the wire). */
export const organizationSetupProgressAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    furthestStep: z.string().nullable(),
    firstMissingStep: z.string().nullable(),
    stepSince: z.string().datetime(),
    steps: z.unknown(),
    checkedAt: z.string().datetime(),
    metaCheckedAt: z.string().datetime().nullable(),
    stuckAlertedAt: z.string().datetime().nullable(),
    nudgedStep: z.string().nullable(),
    nudgeCount: z.number(),
    lastNudgedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationSetupProgress.js.map